export const PUBLIC_HOME_PATH = '/';
export const AUTHENTICATED_HOME_PATH = '/projects';
